import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import axios from "axios";
import ListAdminButtons from "../Common/ListAdminButtons";
import { useHistory } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { userServices } from "../../Services/user.service";
import { globalServices } from "../../Services/global.service";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import SpinnerLoading from "../Common/SpinnerLoading";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";

const TenantsTab = props => {
  const { t: translator } = useTranslation();
  const [data, setData] = useState([]);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [tenants, setTenants] = useState([]);
  const [tenantId, setTenantId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const { roleId } = useContext(AuthContext);
  const { locTab, isMobile } = useContext(GlobalContext);
  const { master, admin, support } = roles;
  const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
    if (locTab === "tenants") {
      setIsLoading(true);
      axios
        .get(props.url)
        .then(res => {
          setData(res.data.data);
          setIsLoading(false);
        })
        .catch(err => console.log(err.response));
    }
  }, [locTab]);
  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "name",
      text: translator("Tentats-TableHeader-Name"),
    },
    {
      dataField: "taxNumber",
      text: translator("Tenants-TableHeader-Oib"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "code",
      text: translator("Tenants-TableHeader-Code"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "street",
      text: translator("Tenants-TableHeader-Address"),
      hidden: Boolean(isMobile),
      formatter: streetFormatter,
    },
    {
      dataField: "city",
      text: translator("Tenants-TableHeader-City"),
      formatter: cityFormatter,
      hidden: Boolean(isMobile),
    },
  ];
  function streetFormatter(cell, row) {
    return `${cell} ${row.streetNumber}`;
  }
  function cityFormatter(cell, row) {
    return `${row.postalNumber}, ${cell}`;
  }
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      history.push(`/tenants/${row.tenantId}`);
    },
  };

  const handleToAdd = () => {
    globalServices
      .getTenantsForDd(props.userId)
      .then(res => {
        let myArray = res.data.filter(
          ar => !data.find(rm => rm.tenantId === ar.id),
        );
        setTenants(myArray);
        if (myArray.length > 0) {
          setTenantId(myArray[0].id);
        }
      })
      .catch(err => console.log(err));
    setShow(true);
  };

  const handleAddUserToTenant = () => {
    userServices
      .addUserToTenant(props.userId, tenantId)
      .then(res =>
        axios
          .get(props.url)
          .then(res => {
            setData(res.data.data);
            setShow(false);
          })
          .catch(err => console.log(err.response)),
      )
      .catch(err => console.log(err));
  };

  const options = { custom: true, totalSize: data.length, sizePerPage: 5 };

  return (
    <>
      <div className="p-1">
        <div className="container-fluid p-0">
          <div className="card-body mb-4">
            <ToolkitProvider
              keyField="userId"
              data={data}
              columns={columns}
              search>
              {props => (
                <div>
                  <SearchBar
                    placeholder={translator("Tenants-Tab-SearchName")}
                    {...props.searchProps}
                  />
                  <ListAdminButtons
                    handleToAdd={
                      [master, admin, support].includes(Number(roleId))
                        ? handleToAdd
                        : null
                    }
                  />
                  <PaginationProvider pagination={paginationFactory(options)}>
                    {({ paginationProps, paginationTableProps }) => (
                      <div>
                        {isLoading && (
                          <div className="dashboard-card-spinner">
                            <SpinnerLoading />
                          </div>
                        )}
                        {!isLoading && (
                          <BootstrapTable
                            keyField="userId"
                            data={data}
                            loading
                            columns={columns}
                            rowEvents={rowEvents}
                            classes={"table-sm"}
                            rowClasses="boostrap-table-row"
                            noDataIndication={translator("No-Data")}
                            {...paginationTableProps}
                            {...props.baseProps}
                          />
                        )}

                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    )}
                  </PaginationProvider>
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>

      {show && (
        <Modal show={show} backdrop="static" keyboard={false} centered>
          <Modal.Header>
            <Modal.Title>{translator("TenantTab-AddUserToTenant")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group col-sm-12">
              <p>{translator("TenantTab-Modal-Tenant")}</p>
              {tenants && tenants.length > 0 ? (
                <select
                  placeholder={translator("SelectStoreTag")}
                  name="tenantId"
                  className="form-control"
                  ref={register({
                    validate: value => value !== "-1",
                  })}
                  onChange={event => {
                    setTenantId(event.target.value);
                  }}>
                  {tenants &&
                    tenants.map(e => <option value={e.id}>{e.name}</option>)}
                </select>
              ) : (
                <p>{translator("No-Data")}</p>
              )}
              {errors.tenantId && errors.tenantId.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setShow(false)}>
              {translator("Btn-Cancel")}
            </button>
            {tenants && tenants.length != 0 ? (
              <button
                onClick={handleSubmit(handleAddUserToTenant)}
                type="button"
                className="btn btn-primary">
                {translator("TenantTab-AddUserToTenant")}
              </button>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default TenantsTab;
